import dayjs from "shared/dayjs";

/**
 * A release date is a plain calendar date, not an instant, so it is formatted without any
 * timezone conversion. The shared `formatDate` helper runs the value through
 * `.tz(getUserTimeZone())`, which shifts a midnight date to the previous day for users in
 * negative-offset zones — wrong for "this release shipped on the 5th".
 */
export function formatReleaseDate(releaseDate: string | null | undefined, dateFormat?: string): string {
    if (!releaseDate) {
        return '';
    }

    const parsed = dayjs(releaseDate);
    if (!parsed.isValid()) {
        return '';
    }

    return parsed.format(dateFormat || 'DD.MM.YYYY');
}

/**
 * Parses a zero-padded "yyyy.MM.dd" version into a numeric sort key, mirroring the server-side
 * PatchNotesVersion helper. Never compare these as strings: "2026.8.5" and "2026.08.05" are the
 * same day but sort differently.
 */
export function versionSortKey(version: string | null | undefined): number {
    if (!version) {
        return -1;
    }

    const parts = version.split('.');
    if (parts.length !== 3) {
        return -1;
    }

    const [year, month, day] = parts.map(part => Number.parseInt(part, 10));
    if ([year, month, day].some(Number.isNaN)) {
        return -1;
    }

    return year * 10000 + month * 100 + day;
}
